import {
  vs2ngaLimitedReleaseDetailConstants,
  createVs2ngaLimitedReleaseDetailConstants,
  editVs2ngaLimitedReleaseDetailConstants,
  addTargetVs2ngaLimitedReleaseDetailConstants,
  removeTargetVs2ngaLimitedReleaseDetailConstants,
  activateVs2ngaLimitedReleaseDetailConstants,
  deactivateVs2ngaLimitedReleaseDetailConstants,
  deleteVs2ngaLimitedReleaseDetailConstants,
} from "../_redux-constants";
import { vs2ngaLimitedReleasesDetailService } from "../../_services";
import { errorExtractor } from "../../_helpers";

function getVs2ngaLimitedReleaseDetail(queryParams) {
  function getVs2ngaLimitedReleaseDetailLoad() {
    return {
      type: vs2ngaLimitedReleaseDetailConstants.VS2NGA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function getVs2ngaLimitedReleaseDetailSuccess(data) {
    return {
      type: vs2ngaLimitedReleaseDetailConstants.VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function getVs2ngaLimitedReleaseDetailFailure(error) {
    return {
      type: vs2ngaLimitedReleaseDetailConstants.VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getVs2ngaLimitedReleaseDetailLoad());
    return vs2ngaLimitedReleasesDetailService
      .getVs2ngaLimitedReleaseDetail(queryParams)
      .then(
        (data) => {
          dispatch(getVs2ngaLimitedReleaseDetailSuccess(data));
        },
        (error) => {
          dispatch(getVs2ngaLimitedReleaseDetailFailure(error?.toString()));
        }
      );
  };
}

function createVs2ngaLimitedReleaseDetail(requestBody, queryParams) {
  function createVs2ngaLimitedReleaseDetailLoad() {
    return {
      type: createVs2ngaLimitedReleaseDetailConstants.CREATE_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function createVs2ngaLimitedReleaseDetailSuccess(data) {
    return {
      type: createVs2ngaLimitedReleaseDetailConstants.CREATE_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function createVs2ngaLimitedReleaseDetailFailure(error) {
    return {
      type: createVs2ngaLimitedReleaseDetailConstants.CREATE_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(createVs2ngaLimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      vs2ngaLimitedReleasesDetailService
        .createVs2ngaLimitedReleaseDetail(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(createVs2ngaLimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              createVs2ngaLimitedReleaseDetailFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function editVs2ngaLimitedReleaseDetail(requestBody, queryParams) {
  function editVs2ngaLimitedReleaseDetailLoad() {
    return {
      type: editVs2ngaLimitedReleaseDetailConstants.EDIT_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function editVs2ngaLimitedReleaseDetailSuccess(data) {
    return {
      type: editVs2ngaLimitedReleaseDetailConstants.EDIT_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function editVs2ngaLimitedReleaseDetailFailure(error) {
    return {
      type: editVs2ngaLimitedReleaseDetailConstants.EDIT_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editVs2ngaLimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      vs2ngaLimitedReleasesDetailService
        .editVs2ngaLimitedReleaseDetail(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(editVs2ngaLimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(editVs2ngaLimitedReleaseDetailFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function addTargetVs2ngaLimitedReleaseDetail(requestBody, queryParams) {
  function addTargetVs2ngaLimitedReleaseDetailLoad() {
    return {
      type: addTargetVs2ngaLimitedReleaseDetailConstants.ADD_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function addTargetVs2ngaLimitedReleaseDetailSuccess(data) {
    return {
      type: addTargetVs2ngaLimitedReleaseDetailConstants.ADD_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function addTargetVs2ngaLimitedReleaseDetailFailure(error) {
    return {
      type: addTargetVs2ngaLimitedReleaseDetailConstants.ADD_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(addTargetVs2ngaLimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      vs2ngaLimitedReleasesDetailService
        .addTargetVs2ngaLimitedReleaseDetail(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(addTargetVs2ngaLimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              addTargetVs2ngaLimitedReleaseDetailFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function removeTargetVs2ngaLimitedReleaseDetail(queryParams) {
  function removeTargetVs2ngaLimitedReleaseDetailLoad() {
    return {
      type: removeTargetVs2ngaLimitedReleaseDetailConstants.REMOVE_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function removeTargetVs2ngaLimitedReleaseDetailSuccess(data) {
    return {
      type: removeTargetVs2ngaLimitedReleaseDetailConstants.REMOVE_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function removeTargetVs2ngaLimitedReleaseDetailFailure(error) {
    return {
      type: removeTargetVs2ngaLimitedReleaseDetailConstants.REMOVE_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(removeTargetVs2ngaLimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      vs2ngaLimitedReleasesDetailService
        .removeTargetVs2ngaLimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(removeTargetVs2ngaLimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              removeTargetVs2ngaLimitedReleaseDetailFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function activateVs2ngaLimitedReleaseDetail(queryParams) {
  function activateVs2ngaLimitedReleaseDetailLoad() {
    return {
      type: activateVs2ngaLimitedReleaseDetailConstants.ACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function activateVs2ngaLimitedReleaseDetailSuccess(data) {
    return {
      type: activateVs2ngaLimitedReleaseDetailConstants.ACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function activateVs2ngaLimitedReleaseDetailFailure(error) {
    return {
      type: activateVs2ngaLimitedReleaseDetailConstants.ACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(activateVs2ngaLimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      vs2ngaLimitedReleasesDetailService
        .activateVs2ngaLimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(activateVs2ngaLimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              activateVs2ngaLimitedReleaseDetailFailure(error?.toString())
            );
            reject(error);
          }
        );
    });
  };
}

function deactivateVs2ngaLimitedReleaseDetail(queryParams) {
  function deactivateVs2ngaLimitedReleaseDetailLoad() {
    return {
      type: deactivateVs2ngaLimitedReleaseDetailConstants.DEACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function deactivateVs2ngaLimitedReleaseDetailSuccess(data) {
    return {
      type: deactivateVs2ngaLimitedReleaseDetailConstants.DEACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function deactivateVs2ngaLimitedReleaseDetailFailure(error) {
    return {
      type: deactivateVs2ngaLimitedReleaseDetailConstants.DEACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deactivateVs2ngaLimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      vs2ngaLimitedReleasesDetailService
        .deactivateVs2ngaLimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(deactivateVs2ngaLimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              deactivateVs2ngaLimitedReleaseDetailFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function deleteVs2ngaLimitedReleaseDetail(queryParams) {
  function deleteVs2ngaLimitedReleaseDetailLoad() {
    return {
      type: deleteVs2ngaLimitedReleaseDetailConstants.DELETE_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function deleteVs2ngaLimitedReleaseDetailSuccess(data) {
    return {
      type: deleteVs2ngaLimitedReleaseDetailConstants.DELETE_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function deleteVs2ngaLimitedReleaseDetailFailure(error) {
    return {
      type: deleteVs2ngaLimitedReleaseDetailConstants.DELETE_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deleteVs2ngaLimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      vs2ngaLimitedReleasesDetailService
        .deleteVs2ngaLimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(deleteVs2ngaLimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              deleteVs2ngaLimitedReleaseDetailFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

export const vs2ngaLimitedReleasesDetailActions = {
  getVs2ngaLimitedReleaseDetail,
  createVs2ngaLimitedReleaseDetail,
  editVs2ngaLimitedReleaseDetail,
  addTargetVs2ngaLimitedReleaseDetail,
  removeTargetVs2ngaLimitedReleaseDetail,
  activateVs2ngaLimitedReleaseDetail,
  deactivateVs2ngaLimitedReleaseDetail,
  deleteVs2ngaLimitedReleaseDetail,
};
